import { Search, Calendar, MessageCircle } from 'lucide-react';
import { StepCard } from '@/components/ui/custom';
import { Reveal } from '@/components/system';

const steps = [
  {
    step: 1,
    title: 'Escolhe um profissional',
    description: 'Explora perfis de psicólogos angolanos qualificados e encontra quem melhor te compreende.',
    icon: Search,
  },
  {
    step: 2,
    title: 'Marca a tua sessão',
    description: 'Escolhe o dia e hora que te convém. Podes pagar de várias formas simples.',
    icon: Calendar,
  },
  {
    step: 3,
    title: 'Conversa com segurança',
    description: 'Fala pelo WhatsApp ou videochamada num espaço confidencial e acolhedor.',
    icon: MessageCircle,
  },
];

export function HowItWorksSection() {
  return (
    <section id="como-funciona" className="section-y scroll-mt-20 section-glass px-3 sm:px-6">
      <div className="mx-auto w-full min-w-0 max-w-6xl">
        <Reveal>
          <div className="mb-6 text-center sm:mb-8">
            <h2 className="mb-2 px-1 text-2xl font-bold text-foreground sm:text-3xl">
              Três passos simples
            </h2>
            <p className="mx-auto max-w-lg text-sm text-muted-foreground sm:text-base">
              Em minutos escolhes o profissional, marcas e falas com segurança.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-4 md:grid-cols-3 md:gap-5">
          {steps.map((step, index) => (
            <Reveal key={step.step} delayMs={index * 100}>
              <StepCard {...step} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
